import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import * as Yup from 'yup'

import Table from '../../../components/Table'
import Button from '../../../components/Button'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, handleChangeAuthors, selectedAuthors }) {


  const [selected, setSelected] = useState(null)

  const renderLi = (data) => {
    const { fio, mid } = data
    return (
      <tr>
        <td
          onClick={() => handleChangeAuthors(data)}
          style={{ backgroundColor: selectedAuthors?.find(el => (el.mid == mid)) ? '#3689FF' : '' }}
        >
          {fio}
        </td>
      </tr>
    )
  }


  const handleChange = (e) => {
    setSelected(
      { [e.target.name]: e.target.value }
    )
  }

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >
            <Table className={styles.table} >
              <thead>
                <tr>
                  <th>Фио</th>
                </tr>
              </thead>
              <tbody>
                {data?.map(renderLi)}
              </tbody>
            </Table>
          </div>
        </div>
        <div className={styles.inputsRow}>
          <Button style={{ margin: '0 auto 20px' }} onClick={closeModal}>Сохранить</Button>
          <Button style={{ margin: '0 auto 20px' }} onClick={closeModal}>Отменить</Button>
        </div>
      </>
    </Modal>

  )
}
